import Axios from "axios";

const dealerCareApi = Axios.create({
  baseURL: process.env.REACT_APP_DEALERCARE_API_URL,
  timeout: 15000,
});

export default dealerCareApi;
